import { z } from "zod";
import { isoDateSchema } from "@common/helpers/date";
import {
    ScheduleChangeJournalEntryMode,
    ScheduleDeleteJournalEntryMode,
    ScheduleStopSettlementKind,
} from "@common/types/domains/accounting/schedule";

export const scheduleActivityIdentitySchema = z
    .object({
        templateId: z.string().uuid(),
        policyName: z.string(),
        group: z.string(),
        sourceLabel: z.string().nullable(),
        entityName: z.string().nullable(),
    })
    .strict();

export const scheduleActivitySettlementSchema = z
    .object({
        kind: z.nativeEnum(ScheduleStopSettlementKind),
        amount: z.number(),
        fromAccount: z.string().nullable(),
        toAccount: z.string().nullable(),
    })
    .strict();

export const scheduleActivityQualifiersSchema = z
    .object({
        changedFields: z.array(z.string()),
        journalEntryMode: z
            .union([
                z.nativeEnum(ScheduleChangeJournalEntryMode),
                z.nativeEnum(ScheduleDeleteJournalEntryMode),
            ])
            .optional(),
        catchUpDate: isoDateSchema.optional(),
        settlement: scheduleActivitySettlementSchema.optional(),
        periodMonths: z.array(z.string()).optional(),
    })
    .strict();

export const scheduleActivityMetadataSchema =
    scheduleActivityQualifiersSchema.extend({
        identity: scheduleActivityIdentitySchema,
    });

export type ScheduleActivityIdentity = z.infer<
    typeof scheduleActivityIdentitySchema
>;
export type ScheduleActivitySettlement = z.infer<
    typeof scheduleActivitySettlementSchema
>;
export type ScheduleActivityQualifiers = z.infer<
    typeof scheduleActivityQualifiersSchema
>;
export type ScheduleActivityMetadata = z.infer<
    typeof scheduleActivityMetadataSchema
>;
